import { APIRoute } from '@/modules/utils'
import { HydraCollection } from 'emt-library'
import { DogAffinityChoice } from '@/data'

export type Response = HydraCollection<DogAffinityChoice>

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/dog_affinity_choices',
}
